import Link from "next/link";
import React, { memo, useMemo } from "react";

import { SectionTitle } from "@/components/atoms/typograhies/SectionTitle";
import ChevronRightIc from "/public/icon/chevron-right.svg";
import {ShortcutTooltip} from "@/components/molecules/tooltips/ShortcutTooltip";
import {NEXT_URL} from "@/utils/const";
import { useUserAccount } from "@/states/auth/selectoers";
import WarningIC from "/public/icon/warning_ic.svg";
import WarningIcon from "@/components/icons/WarningRedIcon";
import { useLoading } from "@/states/loading/operations";
import { accountApi } from "@/apis/accounts/accountApi";
import { ApiResponseError } from "@/apis/errors";
import useApiResponseErrorHandler from "@/hooks/useApiResponseErrorHandler";
import useGetPaymentSetting from "@/hooks/useGetPaymentSetting";

interface Props {
  isReady?: boolean;
  hasServices?: boolean;
  hasUnpaidSubscription?: boolean;
}
const ShortcutView = ({ isReady, hasServices, hasUnpaidSubscription = false }: Props) => {
  const account = useUserAccount();
  const withLoading = useLoading();
  const { handlePageError } = useApiResponseErrorHandler();
  const { connectedAccount, canPayment } = useGetPaymentSetting();
  const hasStripeAccount =
    !!connectedAccount?.user_payment_setting?.stripe_connect_id;

  const createConnectAccount = async () => {
    try {
      await withLoading(async () => {
        const res = await accountApi.postConnectedAccount();
        const url =
          res && res.data && res.data.account_link
            ? new URL(res.data.account_link)
            : null;
        if (url && url.href) {
          window.open(url.href, "_blank");
        }
      });
    } catch (e) {
      if (e instanceof ApiResponseError) {
        void handlePageError(e);
      }
    }
  };
  
  const redirectLinkTopPage = useMemo(() => {
    if (account) {
      if (account.top_page_id) {
        return `/content/edit/page/${account.top_page_id}`;
      }
      return '/content/create?type=17';
    }
    return '';
  }, [account]);
  if (!isReady) return <></>;

  return (
    <>
      <SectionTitle
        title="よく利用されるメニュー"
        className="border-l-2 border-black pl-2"
      />
      {(account?.disabled_reason || (hasStripeAccount && !canPayment)) && (
        <div className="flex items-center bg-[#FFFBDB] py-2 px-4 border-[1px] border-[#FFE58F] rounded-lg mt-5">
          <WarningIC className="mr-2" />
          クレジットカード決済の設定に問題があります。
          <div onClick={() => void createConnectAccount()} style={{cursor: 'pointer'}}>
            <span className="text-[#47BDAB] text-sm underline">こちら</span>
          </div>
          から再設定してください。
        </div>
      )}
      <div className={`grid gap-3 md:grid-cols-4 md:gap-4 ${hasServices ? 'mt-8' : 'mt-16'} `}>
        {hasServices ? (
          <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
            <div className="basis-4/5">
              <Link href={NEXT_URL.CONTENT_CREATE} className="cursor-pointer">

                <h3 className="text-[18px] font-bold">新規コンテンツ作成</h3>

              </Link>
            </div>
            <div className="basis-1/5">
              <Link
                href={NEXT_URL.CONTENT_CREATE}
                className="gap-x-1 text-sm text-black cursor-pointer float-right">

                <ChevronRightIc width="24" fill="#41C9B4"/>

              </Link>
            </div>
          </div>
        ) : (
          <ShortcutTooltip>
            <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
              <div className="basis-4/5">
                <Link href={NEXT_URL.CONTENT_CREATE} className="cursor-pointer">

                  <h3 className="text-[18px] font-bold">新規コンテンツ作成</h3>

                </Link>
              </div>
              <div className="basis-1/5">
                <Link
                  href={NEXT_URL.CONTENT_CREATE}
                  className="gap-x-1 text-sm text-black cursor-pointer float-right">

                  <ChevronRightIc width="24" fill="#41C9B4"/>

                </Link>
              </div>
            </div>
          </ShortcutTooltip>
        )}

        <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
          <div className="basis-4/5">
            <Link href={NEXT_URL.SERVICES} className="cursor-pointer">

              <h3 className="text-[18px] font-bold">コンテンツ一覧</h3>

            </Link>
          </div>
          <div className="basis-1/5">
            <Link
              href={NEXT_URL.SERVICES}
              className="gap-x-1 text-sm text-black cursor-pointer float-right">

              <ChevronRightIc width="24" fill="#41C9B4"/>

            </Link>
          </div>
        </div>
        <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
          <div className="basis-4/5">
            <Link href={NEXT_URL.RESERVATIONS} className="cursor-pointer">

              <h3 className="text-[18px] font-bold">予約一覧</h3>

            </Link>
          </div>
          <div className="basis-1/5">
            <Link
              href={NEXT_URL.RESERVATIONS}
              className="gap-x-1 text-sm text-black cursor-pointer float-right">

              <ChevronRightIc width="24" fill="#41C9B4"/>

            </Link>
          </div>
        </div>
        <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
          <div className="basis-4/5">
            <Link href={NEXT_URL.CUSTOMERS} className="cursor-pointer">

              <h3 className="text-[18px] font-bold">顧客一覧</h3>

            </Link>
          </div>
          <div className="basis-1/5">
            <Link
              href={NEXT_URL.CUSTOMERS}
              className="gap-x-1 text-sm text-black cursor-pointer float-right">

              <ChevronRightIc width="24" fill="#41C9B4"/>

            </Link>
          </div>
        </div>
        <Link href={redirectLinkTopPage}>
          <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
            <div className="basis-4/5">
              <span className="cursor-pointer">
                <h3 className="text-[18px] font-bold">{account && account?.top_page_id ? 'トップページ編集' : 'トップページ作成'}</h3>
              </span>
            </div>
            <div className="basis-1/5">
              <span className="gap-x-1 text-sm text-black cursor-pointer float-right">
                <ChevronRightIc width="24" fill="#41C9B4"/>
              </span>
            </div>
          </div>
        </Link>
        <Link href={NEXT_URL.RESERVATIONS_CREATE}>
          <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
            <div className="basis-4/5">
              <span className="cursor-pointer">
                <h3 className="text-[18px] font-bold">新規申込の登録</h3>
              </span>
            </div>
            <div className="basis-1/5">
              <span className="gap-x-1 text-sm text-black cursor-pointer float-right">
                <ChevronRightIc width="24" fill="#41C9B4"/>
              </span>
            </div>
          </div>
        </Link>
        {hasUnpaidSubscription && (
          <Link href={`${NEXT_URL.RESERVATIONS}?order_status=1&service_type=3`}>
            <div className="px-5 py-3 flex flex-row border-solid border-slate-300 border-[1px] rounded-[10px]">
              <div className="basis-4/5">
                <span className="cursor-pointer flex items-center gap-2">
                  <WarningIcon width={16} height={16} color="#D32932" />
                  <h3 className="text-[18px] font-bold text-red-600">サブスク支払未済</h3>
                </span>
              </div>
              <div className="basis-1/5">
                <span className="gap-x-1 text-sm text-black cursor-pointer float-right">
                  <ChevronRightIc width="24" fill="#41C9B4"/>
                </span>
              </div>
            </div>
          </Link>
        )}
      </div>
    </>
  );
};

export default memo(ShortcutView);
